var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.root},[_c('h1',{class:_vm.$style.heading},[_vm._v(_vm._s(_vm.heading))]),_c('div',{class:_vm.$style.ads},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }